import React from "react";
import AuthCard from "../molecules/AuthCard/AuthCard";

type Props = {};

const WorkplaceCard: React.FC<Props> = (props) => {
  return (
    <AuthCard
      type="workplace"
      heading="Workplace"
      subHeading="Promote DE&I by ensuring that your language and initiatives are inclusive."
      onButtonClick={() => {
        window.location.href = process.env.REACT_APP_WORKPLACE_BASE_URL;
      }}
      buttonText={
        <>
          {/* <span className={styles.google}><GLogo /></span> */}
          <span>Login</span>
        </>
      }
    />
  );
};

export default WorkplaceCard;
